import axios from "./axiosInstance";

const ChangePasswordAPI = {
  postChangePassword: (params) => axios.post(`/change_password`, params),
};

export default ChangePasswordAPI;
